// extracted by mini-css-extract-plugin
export default {"FlipFlop":"flip-flop_FlipFlop__3fTAx","right":"flip-flop_right__1uxUt","left":"flip-flop_left__1C-lo","image":"flip-flop_image__1W_J6","appear":"flip-flop_appear__KJn6x"};